export default {"src":"/_next/static/media/dogOutline75_40.a0dcde48.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};